<div [ngClass]="{ 'z-9999': isFlyoutMenu, 'z-10': !isFlyoutMenu }" class="popOverBox">
  <!--<div class="popOverBox">-->
  <div [ngStyle]="{'background': background}" class="headerBox">
    <div (click)="toggleFlyoutMenu()" class="w-full" tabindex="0">
      <ng-content select="[header]"></ng-content>
    </div>
  </div>
  <!--'Product' flyout menu, show/hide based on flyout menu state.
    Entering: "transition ease-out duration-200"
      From: "opacity-0 -translate-y-1"
      To: "opacity-100 translate-y-0"
    Leaving: "transition ease-in duration-150"
      From: "opacity-100 translate-y-0"
      To: "opacity-0 -translate-y-1"-->
  @if (isFlyoutMenu) {
    <div @opacityTranslateY class="bodyPopover {{bodyClass}}"
         (click)="onBodyClick()"
         [ngStyle]="{ 'width': width, 'padding': padding, 'left': left, 'right': right, 'top':top, 'box-shadow':boxShadow, 'border':border,'background':background }"
    >
      <div class="">
        <ng-content select="[body]"></ng-content>
      </div>
    </div>
  }
</div>
@if (isFlyoutMenu) {
  <div (click)="onBackdrop()" class="backdropPopup"></div>
}
